<template>
  <div class="calculator bmi">
    <h1 class="page-header">Body Mass Index Calculator</h1>

    <base-radio
      id="metric-imperial-selector"
      :value="units"
      :options="[
        { label: 'metric', desc: 'Metric' },
        { label: 'imperial', desc: 'Imperial' },
      ]"
      @set-new-value="units = $event.newValue"
    >
    </base-radio>
    <br />
    <weight-fieldset
      :units="units"
      :weight="weight"
      @change-weight="weight = $event.weight"
    >
    </weight-fieldset>
    <br />
    <height-fieldset
      :units="units"
      :height="height"
      @change-height="height = $event.height"
    >
    </height-fieldset>
    <br />
    <br />
    <div>
      <el-button type="primary" @click="setBMI" round>Calculate BMI</el-button>
    </div>
    <br />
    <br />
    <div v-if="bmi > -1">
      <el-card class="box-card">
        <div class="text result">Your BMI is {{ bmi }}</div>
        <br />
        <div
          v-for="(desc, idx) in BMIDescription.desc"
          :key="'desc-' + idx"
          class="text result description"
        >
          {{ desc }}
        </div>
        <br />
        <div
          v-for="(resource, idx) in BMIDescription.resources"
          :key="'resource-' + idx"
          class="text result resource"
        >
          <a :href="resource" target="_blank">{{ resource }}</a>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import BaseRadio from "@/components/BaseRadio.vue"
import WeightFieldset from "@/components/health/WeightFieldset.vue"
import HeightFieldset from "@/components/health/HeightFieldset.vue"

const BMI_DETAILS = {
  UNDERWEIGHT: {
    desc: ["You are UNDERWEIGHT"],
    resources: [
      "https://www.nhs.uk/live-well/healthy-weight/advice-for-underweight-adults/",
    ],
  },
  HEALTHY: {
    desc: ["You are a HEALTHY WEIGHT"],
    resources: [
      "https://www.nhlbi.nih.gov/health/educational/lose_wt/index.htm",
    ],
  },
  OVERWEIGHT: {
    desc: ["You are OVERWEIGHT"],
    resources: [
      "https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight",
      "https://www.niddk.nih.gov/health-information/weight-management/health-risks-overweight",
    ],
  },
  OBESE: {
    desc: ["You are OBESE"],
    resources: [
      "https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight",
    ],
  },
}

export default {
  name: "BMI",
  components: {
    BaseRadio,
    WeightFieldset,
    HeightFieldset,
  },
  data() {
    return {
      units: "metric",
      weight: 70.0,
      height: 160,
      bmi: -1,
    }
  },
  computed: {
    BMIDescription() {
      if (this.bmi < 18.5) {
        return BMI_DETAILS["UNDERWEIGHT"]
      } else if (this.bmi <= 24.9) {
        return BMI_DETAILS["HEALTHY"]
      } else if (this.bmi <= 29.9) {
        return BMI_DETAILS["OVERWEIGHT"]
      }
      return BMI_DETAILS["OBESE"]
    },
  },
  methods: {
    setBMI() {
      this.bmi = Math.round((this.weight * 10) / (this.height / 100) ** 2) / 10
    },
  },
}
</script>

<style scoped>
</style>
